<div>

  <mat-tab-group>
    <mat-tab label="Alert">

      <mat-form-field class="pe-se-input">
        <mat-label>Description</mat-label>
        <textarea matInput
                  [(ngModel)]="item.data.description">
        </textarea>
      </mat-form-field>
    </mat-tab>

    <mat-tab label="Layout">
      <app-sub-layout-setting [item]="item" [layoutSetting]="layoutSetting"></app-sub-layout-setting>
    </mat-tab>
  </mat-tab-group>

</div>
